import { render, staticRenderFns } from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=template&id=6a7c96df&"
import script from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=script&lang=js&"
export * from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=script&lang=js&"
import style0 from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticPageNotFoundSadWallpaper.vue"
export default component.exports